import React, { useEffect, useState } from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Font,
  Image,
} from "@react-pdf/renderer";
import dayjs from "dayjs";

import salesDood2 from "../utils/salesDood2.png";
import axios from "axios";

Font.register({
  family: "Manrope",
  fonts: [
    {
      src: "/fonts/Manrope-Regular.ttf", // Regular weight
      fontWeight: "normal",
    },
    {
      src: "/fonts/Manrope-Bold.ttf", // Bold weight
      fontWeight: "bold",
    },
    {
      src: "/fonts/Manrope-Medium.ttf", // Medium weight
      fontWeight: "medium",
    },
  ],
});

const styles = StyleSheet.create({
  page: {
    padding: 20,
    fontSize: 10,
    fontFamily: "Manrope",
    paddingBottom: 90,
  },
  // reserved blank space at the very top for letterhead
  headerSpace: {
    height: 80, // adjust height of reserved space
    borderBottomWidth: 1,
    borderBottomColor: "#ccc",
    marginBottom: 10,
  },
  headerRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 12,
  },
  flexRow: {
    flexDirection: "row",
    justifyContent: "left",
    alignItems: "center",
    marginTop: 3,
    marginBottom: 3,
  },
  smallText: {
    fontSize: 9,
    color: "grey",
    marginRight: 4,
  },
  customerDetails: {
    marginTop: 8,
  },
  customerName: {
    fontSize: 11,
    fontWeight: "bold",
  },
  accountDetails: {
    textAlign: "right",
  },
  logo: {
    width: 70,
    height: 20,
    marginBottom: 8,
  },
  mainTitleFirst: {
    textAlign: "center",
    fontSize: 14,
    fontWeight: "bold",
    marginBottom: 4,
  },
  mainTitle: {
    fontSize: 14,
    fontWeight: "bold",
    marginBottom: 4,
  },
  sectionTitle: {
    fontSize: 10,
    fontWeight: "bold",
    marginBottom: 2,
  },
  summaryBox: {
    paddingBottom: 8,
    borderBottom: "1px solid #ccc",
  },
  transactionRow: {
    flexDirection: "row",
    borderBottom: "1px solid #eee",
    // paddingVertical: 6,
  },
  tid: {
    fontSize: 9,
    fontWeight: "bold",
  },
  ref: {
    fontSize: 9,
    color: "grey",
  },
  cell: {
    fontSize: 10,
  },
  cellCredit: {
    color: "red",
    fontWeight: "bold",
  },
  cellDebit: {
    color: "green",
    fontWeight: "bold",
  },
  footerSpace: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    height: 60,
  },
  footer_image: {
    width: "100%",
    height: 60,
    objectFit: "cover",
  },
  footerRow: {
    position: "absolute",
    bottom: 64,
    left: 20,
    right: 20,
    flexDirection: "row",
    justifyContent: "center",
    borderTopWidth: 1,
    borderTopColor: "#ccc",
    paddingTop: 6,
    textAlign: "center",
  },
  footer: {
    fontSize: 9,
    color: "grey",
  },
  pageNumber: {
    fontSize: 9,
    color: "grey",
  },
});

const StatementDocument = ({
  statement,
  statementDataFromAPI,
  accountData,
  statementData,
  statementDataRecordsFromAPI,
  trnData,
}) => {
  console.log("statementDataFromAPI:: StatementDocument", statementDataFromAPI);
  console.log("accountData from documnet::", accountData);
  console.log("statementData from documnetttt::", statementData?.apiData);
  const [accountDetails, setAccountDetails] = useState(null);


  let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
    ? JSON.parse(localStorage.getItem("apiPaths"))
    : "-";

  // const totals = Object.values(statementDataFromAPI?.apiData || {}).reduce(
  // const totals = Object.values(statementData || {}).reduce(
  const totals = Object.values(statementDataRecordsFromAPI || {}).reduce(
    (acc, t) => {
      acc.debit += Number(t.DEBIT || 0);
      acc.credit += Number(t.CREDIT || 0);
      acc.balance = Number(t.BALANCE || acc.balance); // last balance
      return acc;
    },
    { debit: 0, credit: 0, balance: 0 },
  );
  console.log("Total from Print component", totals);
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* Reserved header space for letterhead */}
        <View style={styles.headerSpace} fixed>
          {apiPaths_from_local_storage[0].REP_HEADER.includes("data:image/") ? (
            <Image
              src={apiPaths_from_local_storage[0].REP_HEADER}
              style={styles.header_image}
            />
          ) : null}
        </View>

        {/* Header (below letterhead space) */}
        <Text style={styles.mainTitleFirst}>Account Statement</Text>
        <View style={styles.headerRow}>
          <View>
            <View style={styles.customerDetails}>
              <View style={styles.flexRow}>
                <Text style={styles.smallText}>Account:</Text>

                <Text style={styles.sectionTitle}>
                  {statementDataFromAPI?.selectedAccountToAPI}
                </Text>
              </View>

              <Text style={styles.sectionTitle}>
                {statementDataFromAPI?.selectedAccountNameToAPI}
              </Text>
              <View style={styles.flexRow}>
                <Text style={styles.smallText}>TRN:</Text>

                <Text style={styles.sectionTitle}>{trnData}</Text>
              </View>
              {/* {statementDataFromAPI?.selectedAccountPhoneToAPI && ( */}
              <View style={styles.flexRow}>
                <Text style={styles.smallText}>Phone:</Text>
                <Text style={styles.sectionTitle}>
                  {statementDataFromAPI?.selectedAccountPhoneToAPI}
                </Text>
              </View>
              {/* )} */}
            </View>
          </View>
          {/* <Text style={styles.mainTitle}>Account Statement</Text> */}
          <View style={styles.accountDetails}>
            <Text style={styles.smallText}>Statement Period</Text>
            <Text style={styles.sectionTitle}>
              {/* {dayjs(accountData?.fromDate).format("MMM D, YYYY")} -{" "} */}
              {/* {dayjs(accountData?.toDate).format("MMM D, YYYY")} */}
              {dayjs(accountData?.fromDate).format("DD/MM/YYYY")} -{" "}
              {dayjs(accountData?.toDate).format("DD/MM/YYYY")}
            </Text>
            {/* <Text>Currency: {accountDetails?.currency}</Text> */}
            <Text>Credit Limit: {accountDetails?.climit}</Text>
            <Text>Due Days: {accountDetails?.duedays}</Text>
          </View>
        </View>

        {/* Transactions Header */}
        <View style={[styles.transactionRow]}>
          <Text style={[styles.cell, { flex: 1, fontWeight: "bold" }]}>
            Date
          </Text>
          <Text style={[styles.cell, { flex: 1, fontWeight: "bold" }]}>
            Details
          </Text>
          <Text style={[styles.cell, { flex: 1, fontWeight: "bold" }]}>
            Description
          </Text>
          <Text
            style={[
              styles.cell,
              { flex: 0.8, fontWeight: "bold", textAlign: "right" },
            ]}
          >
            Debit
          </Text>
          <Text
            style={[
              styles.cell,
              { flex: 0.7, fontWeight: "bold", textAlign: "right" },
            ]}
          >
            Credit
          </Text>
          <Text
            style={[
              styles.cell,
              { flex: 0.8, fontWeight: "bold", textAlign: "right" },
            ]}
          >
            Balance
          </Text>
        </View>

        {/* Transactions Loop */}
        {/* {Object.values(statementDataFromAPI.apiData || {})?.map((t, idx) => ( */}
        {Object.values(statementDataRecordsFromAPI || {})?.map((t, idx) => (
          <View key={idx} style={styles.transactionRow}>
            {/* Date */}
            <Text style={[styles.cell, { flex: 1 }]}>
              {/* {t.DATE?.slice(0, 10)} */}
              {dayjs(t.DATE?.slice(0, 10)).format("DD-MM-YYYY")}
            </Text>
            <View
              style={{
                flex: 1.2,
                borderLeftWidth: 1,
                borderLeftColor: t.DEBIT ? "green" : "red",
                paddingLeft: 4,
                marginLeft: 6,
              }}
            >
              {/* Type + Ref compact */}
              <View style={{ flex: 2, flexDirection: "column" }}>
                <Text style={[styles.ref]}>{t.TYPE || "-"}</Text>
                <Text style={[styles.ref]}>Ref: {t.REF || "-"}</Text>
              </View>
            </View>

            {/* Description */}
            <Text style={[styles.cell, { flex: 1.5 }, { paddingBottom: 14 }]}>
              {t.DESCRIPTION || "-"}
            </Text>

            {/* Debit */}
            <Text
              style={[
                styles.cell,
                { flex: 1, color: "green", textAlign: "right" },
              ]}
            >
              {t.DEBIT ? Number(t.DEBIT).toFixed(2) : "-"}
              {/* 100000.00 */}
            </Text>

            {/* Credit */}
            <Text
              style={[
                styles.cell,
                { flex: 1, color: "red", textAlign: "right" },
              ]}
            >
              {t.CREDIT ? Number(t.CREDIT).toFixed(2) : "-"}
              {/* 100000.00 */}
            </Text>

            {/* Balance */}
            <Text style={[styles.cell, { flex: 1, textAlign: "right" }]}>
              {t.BALANCE ? Number(t.BALANCE).toFixed(2) : "-"}
              {/* {(Number(t.DEBIT || 0) - Number(t.CREDIT || 0)).toFixed(2)} */}
            </Text>
          </View>
        ))}

        <View
          style={[
            styles.transactionRow,
            {
              borderTopWidth: 1,
              borderTopColor: "#000",
              marginTop: 6,
              paddingTop: 6,
            },
          ]}
        >
          <Text style={[styles.cell, { flex: 1, fontWeight: "bold" }]}>
            TOTAL
          </Text>

          <Text style={[styles.cell, { flex: 1 }]} />

          <Text style={[styles.cell, { flex: 2.5 }]} />

          {/* Debit Total */}
          <Text
            style={[
              styles.cell,
              {
                flex: 1,
                textAlign: "right",
                fontWeight: "bold",
                color: "green",
              },
            ]}
          >
            {totals.debit.toFixed(2)}
          </Text>

          {/* Credit Total */}
          <Text
            style={[
              styles.cell,
              {
                flex: 1,
                textAlign: "right",
                fontWeight: "bold",
                color: "red",
              },
            ]}
          >
            {totals.credit.toFixed(2)}
          </Text>

          {/* Balance */}
          {/* <Text
            style={[
              styles.cell,
              { flex: 1, textAlign: "right", fontWeight: "bold" },
            ]}
          >
            {totals.balance.toFixed(2)}
          </Text> */}
          <Text
            style={[
              styles.cell,
              {
                flex: 1,
                textAlign: "right",
                fontWeight: "bold",
                // color: totals.debit - totals.credit < 0 ? "green" : "red",
              },
            ]}
          >
            {Math.abs(totals.debit - totals.credit).toFixed(2)}
          </Text>
        </View>
        {/* Footer */}
        <View style={styles.footerSpace} fixed>
          {apiPaths_from_local_storage[0]?.REP_FOOTER?.includes(
            "data:image/",
          ) ? (
            <Image
              src={apiPaths_from_local_storage[0].REP_FOOTER}
              style={styles.footer_image}
            />
          ) : null}
        </View>
        <View style={styles.footerRow}>
          {/* <Text style={styles.footer}>Copyright © MTBS.co 2025</Text> */}
          <Text
            style={styles.pageNumber}
            render={({ pageNumber }) => `Page ${pageNumber}`}
            fixed
          />
        </View>
      </Page>
    </Document>
  );
};

export default StatementDocument;
